import React, { useEffect, useContext } from 'react'
import { graphql } from 'gatsby'
import { LayoutContext, useUI } from '../contexts'
import TechnologyHero from '../components/technology/TechnologyHero'
import TechnologyIntroduction from '../components/technology/TechnologyIntroduction'
import TechnologyUsp from '../components/technology/TechnologyUsp'
import TechnologyBoard from '../components/technology/TechnologyBoard'
import SEO from '../components/SEO'
import { useTechnologyPageViewedTracking } from '../hooks/tracking'

const Technology = ({
  location,
  data: {
    contentfulTechnologyPage: {
      heroHeading,
      heroBody,
      heroVideo,
      introductionHighlights,
      introductionCopy,
      introductionCopyTwo,
      introductionImage,
      uspVideo,
      uspSideVideo,
      upsAccordionItems,
      boardHeading,
      seoTitle,
      seoDescription,
      boardMemberName1,
      boardMemberTitle1,
      boardMemberDescription1,
      boardMemberImage1,
      boardMemberName2,
      boardMemberTitle2,
      boardMemberDescription2,
      boardMemberImage2,
    },
  },
}) => {
  const { node_locale, currency } = useContext(LayoutContext)
  useEffect(() => {
    useTechnologyPageViewedTracking({
      currency: currency?.code,
      locale: node_locale,
    })
  })
  return (
    <>
      <SEO
        isPage
        location={location}
        title={seoTitle}
        description={seoDescription}
        pageCategory={'Technology'}
        referrer={location.state?.referrer}
      />
      <TechnologyHero
        heroHeading={heroHeading}
        heroBody={heroBody}
        heroVideo={heroVideo}
      />
      <TechnologyIntroduction
        introductionHighlights={introductionHighlights}
        introductionCopy={introductionCopy}
        introductionCopyTwo={introductionCopyTwo}
        introductionImage={introductionImage}
      />
      <TechnologyUsp
        uspVideo={uspVideo}
        uspSideVideo={uspSideVideo}
        upsAccordionItems={upsAccordionItems}
      />
      <TechnologyBoard
        boardHeading={boardHeading}
        boardMemberName1={boardMemberName1}
        boardMemberTitle1={boardMemberTitle1}
        boardMemberDescription1={boardMemberDescription1}
        boardMemberImage1={boardMemberImage1}
        boardMemberName2={boardMemberName2}
        boardMemberTitle2={boardMemberTitle2}
        boardMemberDescription2={boardMemberDescription2}
        boardMemberImage2={boardMemberImage2}
      />
    </>
  )
}

export const TechnologyQuery = graphql`
  query Technology($id: String!) {
    contentfulTechnologyPage(id: { eq: $id }) {
      seoTitle
      seoDescription
      boardHeading
      upsAccordionItems {
        title
        content {
          raw
        }
      }
      uspVideo {
        videoMp4 {
          file {
            url
          }
        }
        videoWebm {
          file {
            url
          }
        }
        poster {
          fluid(sizes: "(max-width: 100vw) 100vw, 100vw") {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
      }
      uspSideVideo {
        poster {
          fluid(sizes: "(max-width: 1023px) 50vw, 29vw") {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
        videoMp4 {
          file {
            url
          }
        }
        videoWebm {
          file {
            url
          }
        }
      }
      introductionHighlights
      introductionCopy {
        raw
      }
      introductionCopyTwo {
        raw
      }
      introductionImage {
        fluid(sizes: "(max-width: 1023px) 100vw, 37vw") {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      heroHeading
      heroBody {
        heroBody
      }
      heroVideo {
        poster {
          fluid(sizes: "(max-width: 100vw) 100vw, 100vw") {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
        videoMp4 {
          file {
            url
          }
        }
        videoWebm {
          title
          file {
            url
          }
        }
      }
      boardMemberName1
      boardMemberTitle1
      boardMemberDescription1 {
        boardMemberDescription1
      }
      boardMemberImage1 {
        title
        fluid(sizes: "(max-width: 1023px) 50vw, 34vw") {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      boardMemberName2
      boardMemberTitle2
      boardMemberDescription2 {
        boardMemberDescription2
      }
      boardMemberImage2 {
        title
        fluid(sizes: "(max-width: 1023px) 50vw, 34vw") {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
    }
  }
`

export default Technology
